import { fade as muiFade } from '@material-ui/core/styles'; // temporary utility fade wrapper to reduce boilerplate code
// should be moved to theme module once it supports ts

export var fade = function fade(background, opacity) {
  return !(typeof background === 'string') || !(typeof opacity === 'number') || background === 'none' ? 'none' : muiFade(background, opacity);
};
//# sourceMappingURL=fade.js.map